import React from 'react'

function MessageError({ message }) {
  return (
    <div className="message message--error">
      <div className="site-message">{message}</div>
    </div>
  )
}

export default MessageError
